<template>
<div class="row clearfix">
  <div v-if="loading">
    <BlockUI :message="blockuimsg"></BlockUI>
  </div>
  <div class="card">
    <div class="body">
    <div class="col-lg-12">
      <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
      <br>
      <ValidationObserver ref="formValidation">
      <b-row>
        <b-col  style="text-align:center">
          <strong>Operaciones del ejercicio</strong>
          <b-button v-if="arrayEleOperation.length > 1" @click="removeArrayEleOperation()" class="btn btn-danger ml-2" size="sm">-</b-button>
          <b-button @click="addArrayEleOperation()" class="btn btn-primary ml-2" size="sm">+</b-button>
        </b-col>
      </b-row>
      <div>
        <div v-for="(operation, index) in arrayEleOperation" v-bind:key="index">
            <b-row class="justify-content-md-center" style="margin-bottom: 10px">
              <b-col col lg="12">
                <label>Ficha de contenido</label>
                  <ValidationProvider rules="required" v-slot="{ errors }">
                    <div class="col-md-12 d-inline-flex align-items-center">
                       <i class="zmdi zmdi-link pointer pr-2 text-primary"
                        v-if="arrayEleOperation[index].CONTENIDOS_ID_PRINCIPAL !== null && arrayEleOperation[index].CONTENIDOS_ID_PRINCIPAL !== 0"
                        @click="openResourceWithParam('contentsheets', arrayEleOperation[index].CONTENIDOS_ID_PRINCIPAL)"/>
                      <input type="text" v-model="arrayEleOperation[index].CONTENIDOS_NOMBRE"
                        disabled class="form-control" />
                        <searchsheets class="pl-2"
                          v-bind:idModal="'mdlSearchFicha_'+index"
                          v-on:selected="onSelectedSheet($event, index)">
                        </searchsheets>
                    </div>
                    <span class="validation-error">{{ errors[0] }}</span>
                  </ValidationProvider>
              </b-col>
            </b-row>
        </div>
      </div>
      <br>
      <b-row>
        <b-col class="text-center">
          <button v-on:click="saveStorage" :disabled="arrayEleOperation.length < 1" class="btn btn-info btn-lg">
          Guardar
        </button>
        </b-col>
      </b-row>
      </ValidationObserver>
    </div>
    </div>
  </div>
</div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import exercises from '../../exercises/exercise.vue';
import searchsheets from '../../contentsheets/SearchSheets.vue';
import engineMixin from '../../../../mixins/engine';

extend('required', {
  ...required,
  message: 'Campo obligatorio.',
});

export default {
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  mixins: [engineMixin],
  components: {
    exercises,
    ValidationProvider,
    ValidationObserver,
    searchsheets,
  },
  data() {
    return {
      arrayEleOperation: [],
      // Mapear con los campos de la tabla FICHASCONTENIDO_CONF
      configuration: {
        ID: -1,
        EJERCICIOS_ID: -1, //
      },
    };
  },
  methods: {
    removeArrayEleOperation() {
      this.arrayEleOperation.pop();
    },
    addArrayEleOperation() {
      this.arrayEleOperation.push({
        POSICION: this.arrayEleOperation.length + 1,
        CONTENIDOS_ID_PRINCIPAL: null,
        CONTENIDOS_NOMBRE: null,
        CONTENIDOS_TIPO_RESPUESTA: null,
      });
    },
    async getMotorData(id) {
      this.loading = true;

      try {
        const response = await this.axios.get('fichacontenido/getfichacontenido', {
          params: {
            ejercicios_id: id,
          },
        });
        this.configuration = response.data.config;
        response.data.elements.forEach((element) => {
          this.arrayEleOperation.push({
            POSICION: element.POSICION,
            CONTENIDOS_ID_PRINCIPAL: element.CONTENIDOS_ID_PRINCIPAL,
            CONTENIDOS_NOMBRE: element.CONTENIDOS_NOMBRE,
            CONTENIDOS_TIPO_RESPUESTA: element.CONTENIDOS_TIPO_RESPUESTA,
          });
        });
      } catch (e) {
        this.$toasted.show('Ocurrió un error al leer el ejercicio', { type: 'warning' });
      }

      this.loading = false;
    },
    /**
    * @method onSelectedSheet
    * @description Al buscar una ficha de contenido
    */
    onSelectedSheet(itemSelected, idOperation) {
      this.arrayEleOperation[idOperation].CONTENIDOS_TIPO_RESPUESTA = itemSelected.TIPO_RESPUESTA;
      this.arrayEleOperation[idOperation].CONTENIDOS_NOMBRE = itemSelected.NOMBRE;
      this.arrayEleOperation[idOperation].CONTENIDOS_ID_PRINCIPAL = itemSelected.ID;
      this.$root.$emit('bv::hide::modal', `mdlSearchFicha_${idOperation}`);
    },
  },
  async mounted() {
    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
      await this.getMotorData(this.exercise.ID);
    }
    // Read from storage data
    this.readFromStorage(this.type);
    this.updatedNumOperation();
  },
};
</script>
